<ng-container *transloco="let t">
  <app-algo-mode-selection
    [selectedAlgoModeConfig]="algoModeConfigInit()"
    [targetOnlyMode]="true"
    [disabled]="!!data.readonly"
    [strategyId]="data.strategy.strategyId"
    [currencyCode]="data.currencyCode"
    (algoModeConfig)="algoModeConfig.set($event)"
  />

  <div class="flex justify-between pt-4">
    <button iButton variant="secondary" [disabled]="updateLoading()" (click)="ref.close()">
      {{ t("common.cancel") }}
    </button>
    <button
      iButton
      testId="btn-confirm"
      type="submit"
      class="w-2/4"
      [loading]="updateLoading()"
      [disabled]="disabled()"
      (click)="update()"
    >
      {{ t("common.update") }}
    </button>
  </div>
</ng-container>
